/* eslint-disable no-restricted-syntax */
/* eslint-disable global-require */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/extensions */
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import { connect } from "react-redux";

import {
  loginRequest,
  setUserRole,
  setAppBarName,
  setLayoutName,
} from "../../Redux/Actions/LoginActions";
import styles from "../../assets/jss/material-dashboard-react/views/LoginPage.js";

const useStyles = makeStyles(styles);
const SessionOut = (props) => {
  const classes = useStyles();
  const loginPath = localStorage.getItem("loginPath");
  const adminLoginPath = localStorage.getItem("adminLoginPath");

  const onClick = () => {
    if (loginPath) {
      props.prop.history.push(loginPath);
      localStorage.removeItem("loginPath");
      localStorage.clear()
    } else if (adminLoginPath) {
      props.prop.history.push(adminLoginPath);
      localStorage.removeItem("adminLoginPath");
      localStorage.clear()
    } else {
      props.prop.history.push("/");
      localStorage.clear()
    }
  };

  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs>
          <div className={classes.root}>
            <img
              className={classes.logo}
              src={require("../../assets/img/vikingstransparent_logo.png")}
            />
            <Typography color="textPrimary" variant="h4" gutterBottom>
              uh oh!
            </Typography>
            <Typography color="textPrimary" variant="body1" gutterBottom>
              Looks like your session has timed out and we need to log you in
              again.
            </Typography>
            <Typography color="textPrimary" variant="body1" gutterBottom>
              Click on the button below to log in:
            </Typography>
            <Button
              onClick={onClick}
              variant="contained"
              color="primary"
              size="large"
            >
              Login Again
            </Button>
          </div>
        </GridItem>
      </GridContainer>
    </div>
  );
};

SessionOut.propTypes = {
  history: PropTypes.object,
  prop: PropTypes.any,
};

const mapStateToProps = ({ app }) => ({
  userData: app.userDetails,
});
export default connect(mapStateToProps, {
  loginRequest,
  setUserRole,
  setAppBarName,
  setLayoutName,
})(SessionOut);
